/**
 * Una coda di chiamate per torneo, a livello di MODULO (revisione indipendente #505, 🟡2).
 *
 * `POST /social/watch/:id` (join) e `DELETE` (leave) non sono commutativi lato server: `leaveWatch`
 * fa un `findOne` prima di `srem`, `joinWatch` fa `sadd` subito. Con hidden → visible rapido, o col
 * doppio montaggio di StrictMode (join, leave, join), il `srem` può cadere DOPO il `sadd` e lo
 * spettatore resta FUORI dal set mentre guarda, fino al join successivo. Quindi ogni chiamata parte
 * solo dopo la RISPOSTA della precedente sullo stesso torneo, esito qualunque (una join fallita non
 * blocca il leave che la segue: il server può aver scritto prima di rispondere in errore).
 *
 * ⚠️ Sta nel MODULO e non dentro l'effetto: sotto StrictMode l'effetto gira due volte con due
 * chiusure diverse, e una coda per chiusura non ordinerebbe la seconda rispetto alla prima.
 * ⚠️ Un torneo non aspetta un altro: la chiave è l'id, un cambio di `tournamentId` non si mette in
 * fila dietro il torneo precedente.
 *
 * A coda vuota la chiamata non aspetta nessuno.
 *
 * ⚠️ Una chiamata che non risponde MAI fermerebbe quel torneo per tutta la sessione (revisione
 * indipendente #505, 2° giro, 🟡2): per questo join e leave hanno un tempo massimo per richiesta,
 * `WATCH_TIMEOUT_MS`, e un timeout è un esito come un altro — la coda va avanti. Dopo un timeout il
 * server può comunque applicare la chiamata, quindi l'ordine non è più garantito: è un limite
 * dichiarato, non una promessa.
 */
export const WATCH_TIMEOUT_MS = 10_000;

const code = new Map<string, Promise<unknown>>();

export function inCodaPerTorneo<T>(tournamentId: string, chiamata: () => Promise<T>): Promise<T> {
  const prima = code.get(tournamentId);
  const questa: Promise<T> = prima ? prima.then(chiamata, chiamata) : chiamata();
  code.set(tournamentId, questa);
  const pulisci = () => {
    // Solo se nessuno si è accodato dopo: altrimenti la coda è ancora viva.
    if (code.get(tournamentId) === questa) code.delete(tournamentId);
  };
  questa.then(pulisci, pulisci);
  return questa;
}
